function getAPIToken() {
    const rawCookie = document.cookie || '';
    const cookie = rawCookie.split(';').reduce((a, b) => {
        const [key, value] = b.split('=').map((str) => str.trim());
        a[key] = value;
        return a;
    }, {});
    return cookie['tappieApiToken'] || '';
}

export const header = {
    'Content-Type': 'application/json'
};

export const tokenHeader = {
    ...header,
    'tappie-api-token': getAPIToken()
};

export const accessTokenHeader = (accessToken) => ({
    ...header,
    'x-access-token': accessToken
});

export const idTokenHeader = (idToken) => ({
    ...header,
    'tappie-id-token': idToken.token
});
